var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.939,
    height: 14.939,
    viewBox: "0 0 14.939 14.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.047 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16349",
    "data-name": "Path 16349",
    d: "M171.6,13.939c-.258,0-.467-.306-.467-.685V.685c0-.378.209-.685.467-.685s.467.306.467.685v12.57C172.065,13.632,171.855,13.939,171.6,13.939Z",
    transform: "translate(-164.176)",
    fill: "#047dd6",
    stroke: "#047dd6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29627",
    "data-name": "Path 29627",
    d: "M171.6,13.939c-.258,0-.467-.306-.467-.685V.685c0-.378.209-.685.467-.685s.467.306.467.685v12.57C172.065,13.632,171.855,13.939,171.6,13.939Z",
    transform: "translate(14.391 -164.628) rotate(90)",
    fill: "#047dd6",
    stroke: "#047dd6",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3330d8acaa2403c36f7e72c2dbf4d9a7.svg";
export { ForwardRef as ReactComponent };